module.exports = __webpack_public_path__ + "img/slide11-piece-32.d63292ae.png";